module.exports = __webpack_public_path__ + "img/loginBackground.8063530c.png";